import React, { useContext, useState } from "react";
import intl from "react-intl-universal";
import styled from "styled-components";
import { mdiAccountAlertOutline, mdiAccountArrowUpOutline, mdiLockReset } from "@mdi/js";

import userRest from "../../../rest/userRest";

import { Output } from "../../components/Output";
import { Confirm } from "../../components/Confirm";
import { UserContext } from "../../contexts/UserContext";
import { DropdownCaret, Option } from "../../components/DropdownCaret";

const LeftCellStyle = styled.td`
    text-align: left;
    > div {
        height: 12px;
    }
`;

const MenuCellStyle = styled.td`
  >div {
      margin-top: -3px;
      margin-bottom: -10px;
  }
`;

const df = new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" });

export const UserItem = ({ user }) => {

    const userContext = useContext(UserContext);
    const [showActivationConfirmation, setShowActivationConfirmation] = useState(false);
    const [showDeactivationConfirmation, setShowDeactivationConfirmation] = useState(false);
    const [showResetPasswordConfirmation, setShowResetPasswordConfirmation] = useState(false);

    const activate = async () => {
        await userRest.setActiveById(user.id, true);
        setShowActivationConfirmation(false);
    };

    const deactivate = async () => {
        await userRest.setActiveById(user.id, false);
        setShowDeactivationConfirmation(false);
    };

    const resetPassword = async () => {
        await userRest.resetPasswordById(user.id);
        setShowResetPasswordConfirmation(false);
    };

    const isCurrentUser = () => user.id === userContext.user.id;

    return (
        <>
            <tr>
                <MenuCellStyle width="5">
                    <DropdownCaret>
                        <Option
                            svgIcon={mdiAccountArrowUpOutline}
                            disabled={user.active || isCurrentUser()}
                            onClick={() => setShowActivationConfirmation(true)}>
                            {intl.get("user.activate")}
                        </Option>
                        <Option
                            svgIcon={mdiAccountAlertOutline}
                            disabled={!user.active || isCurrentUser()}
                            onClick={() => setShowDeactivationConfirmation(true)}>
                            {intl.get("user.deactivate")}
                        </Option>
                        <Option
                            svgIcon={mdiLockReset}
                            onClick={() => setShowResetPasswordConfirmation(true)}>
                            {intl.get("user.resetPassword")}
                        </Option>
                    </DropdownCaret>
                </MenuCellStyle>
                <LeftCellStyle>{user.username}</LeftCellStyle>
                <LeftCellStyle>{user.email}</LeftCellStyle>
                <LeftCellStyle>{user.createdAt ? df.format(user.createdAt) : ""}</LeftCellStyle>
                <LeftCellStyle>
                    <Output value={user.active} type="boolean" />
                </LeftCellStyle>
                <LeftCellStyle>
                    <Output value={user.administrator} type="boolean" />
                </LeftCellStyle>
            </tr>
            {showActivationConfirmation &&
                <Confirm
                    title={intl.get("user.activate")}
                    body={intl.get("user.activateConfirmation", { username: user.username })}
                    confirm={intl.get("common.ok")}
                    onConfirm={() => activate()}
                    onClose={() => setShowActivationConfirmation(false)} />
            }
            {showDeactivationConfirmation &&
                <Confirm
                    title={intl.get("user.deactivate")}
                    body={intl.get("user.deactivateConfirmation", { username: user.username })}
                    confirm={intl.get("common.ok")}
                    onConfirm={() => deactivate()}
                    onClose={() => setShowDeactivationConfirmation(false)} />
            }
            {showResetPasswordConfirmation &&
                <Confirm
                    title={intl.get("user.resetPassword")}
                    body={intl.get("user.resetPasswordConfirmation", { username: user.username })}
                    confirm={intl.get("common.ok")}
                    onConfirm={() => resetPassword()}
                    onClose={() => setShowResetPasswordConfirmation(false)} />
            }
        </>
    );
};